module.exports = __webpack_public_path__ + "img/Family-photo.033dd45e.webp";